<template>

	<form class="wrap--xsm__left margin-b-150" @submit.prevent="submitSelection">

		<section class="col-12 margin-b-75">

			<label>Navn på gruppen af tilvalg?</label>

			<input class="col-12" type="text" name="name" placeholder="Hvad er navnet?" minlength="2" maxlength="120" required v-model="newSelection.title">

		</section>

		<section class="col-12">

			<button class="btn btn--md btn--secondary secondary--grey" :disabled="!validateForm || isSaving || shouldLock">

				<span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

				<span>Gem tilvalgsgruppe</span>

			</button>

		</section>

	</form>

</template>

<script>
	import {mapGetters} from 'vuex';
    import {v4 as uuidv4} from 'uuid';

    export default {
        name: "selectionForm",
		props:['selection', 'shouldLock'],
        data(){
            return {
                newSelection:{
                    id:'',
                    title:'',
                },
                isSaving:false,
				isCreating:false,
            };

        },
        computed:{
			validateTitle(){
                return this.newSelection.title !== '' && String(this.newSelection.title).length > 0;
			},
			validateForm(){
                return this.validateTitle;
			}
        },
		methods:{
            submitSelection(){
                if(this.isSaving){
                    return;
				}

				if(this.isCreating){
				    return this.createSelection();
				}

				this.updateSelection();
			},
			createSelection(){
				this.isSaving = true;
				const data = {
                    id: uuidv4(),
				    title: this.newSelection.title,
					options:[],
				};
				this.$emit('completed', data);
			},
			updateSelection(){
                this.isSaving = true;
                const data = {
                    id: this.newSelection.id,
                    title: this.newSelection.title,
                    options: this.newSelection.options
                };
                this.$emit('completed', data);
			},
		},
		created(){
            if(this.selection){

                this.newSelection = this.selection;

                return;
			}


			this.isCreating = true;
		}
    }
</script>

<style scoped>

</style>
